import { Layout, Menu, MenuProps } from 'antd'
import MenuItem from 'antd/es/menu/MenuItem'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useStore } from '../store/basic-store'
import { User } from '../types'
import { logoutAction } from '../service/auth'
import { Content } from 'antd/es/layout/layout'
import Sider from 'antd/es/layout/Sider'

export type MenuTypes = 'home' | 'login' | 'my-games' | 'games' | 'groups' | 'adulting-101'
export function HeaderMenu({ selected }: { selected: MenuTypes }) {
  const navigate = useNavigate()
  const [current, setCurrent] = useState<MenuTypes>(selected)
  const [displayStocksMenu] = useState<boolean>(false)
  const user = useStore<User>('user')
  const myGames = useStore<{ id: string }[]>('my-games')
  const onClick: MenuProps['onClick'] = (e) => {
    setCurrent(e.key as MenuTypes)
  }

  return (
    <Layout style={{ maxHeight: '45px' }}>
      <Content style={{ background: 'white', lineHeight: '45px' }}>
        <Menu onClick={onClick} selectedKeys={[current]} mode="horizontal">
          <MenuItem
            key="home"
            onClick={() => {
              navigate('/')
              // setDisplayStocksMenu(false)
            }}
          >
            Home
          </MenuItem>
          <MenuItem key="adulting-101" onClick={() => navigate('/adulting-101')}>
            Adulting 101
          </MenuItem>

          {user ? (
            <>
              <MenuItem key="games" onClick={() => navigate('/games')}>
                Games
              </MenuItem>

              {myGames?.length ? (
                <MenuItem key="my-games" onClick={() => navigate('/my-games')}>
                  My Games
                </MenuItem>
              ) : null}

              <MenuItem key="groups" onClick={() => navigate('/groups')}>
                Groups
              </MenuItem>

              <MenuItem key="logout" onClick={() => logoutAction()}>
                Logout
              </MenuItem>
            </>
          ) : (
            <>
              <MenuItem key="login" onClick={() => navigate('/login')}>
                Login
              </MenuItem>
            </>
          )}
        </Menu>
        <Menu
          onClick={onClick}
          selectedKeys={[current]}
          mode="horizontal"
          style={{ textAlign: 'left', display: displayStocksMenu ? 'block' : 'none' }}
        >
          <MenuItem key="dlist" onClick={() => navigate('/dlist/dividend')}>
            Epic Dividend List
          </MenuItem>
          <MenuItem key="swing-trade" onClick={() => navigate('/dlist/swing-trade')}>
            Stock Screener
          </MenuItem>
          <MenuItem key="watch-list" onClick={() => navigate('/dlist/watch-list')}>
            Watch Lists
          </MenuItem>
        </Menu>
      </Content>
      <Sider className="header-greeting" style={{ background: 'white', lineHeight: '45px' }}>
        <div>{user ? <div onClick={() => navigate('/profile')}>Welcome {user.username}</div> : 'Greetings Programs'}</div>
      </Sider>
    </Layout>
  )
}

/*
(
            <MenuItem key="login" onClick={() => navigate("/login")}>
              Login
            </MenuItem>
          )
*/
